import { Component, OnInit } from '@angular/core';
import { UnsubModel } from './unsub.model';
import { UnsubService } from './unsub.service';
import { Event, RouterEvent,Router } from '@angular/router';
import { filter } from 'rxjs/internal/operators/filter';

@Component({
  selector: 'app-unsub-form',
  templateUrl: './unsub-form.component.html',
  styleUrls: ['./unsub-form.component.css']
})
export class UnsubFormComponent implements OnInit {

  private unsubs:UnsubModel[];
  private _newUnsubName:string;
  private _newUnsubDescription:string;
  public get newUnsubDescription(): string {
    return this._newUnsubDescription;
}
public set newUnsubDescription(description: string){
    this._newUnsubDescription = description;
}  
  public get newUnsubName(): string {
    return this._newUnsubName;
}
public set newUnsubName(name: string){
    this._newUnsubName = name;
}
  constructor(private unsubService:UnsubService, private router:Router) { 
    router.events.pipe(filter((e: Event): e is RouterEvent => e instanceof RouterEvent)
   ).subscribe((e: RouterEvent) => {
     console.log("something changed")
   });
  }

  ngOnInit() {
  }
  public addNewUnsub(): void {
    console.log("New unsub requested");
    this.unsubService.addUnsub(new UnsubModel(this.newUnsubName,this.newUnsubDescription,0)).subscribe(unsub => {
        console.log("Success, got response: " + unsub);
        console.dir(unsub);
        this.newUnsubName = "";
        this.newUnsubDescription = "";
        this.unsubs = unsub;     
        this.router.navigateByUrl('/unsubs'); 
   });
}
}
